import { createReducer } from 'redux-act';
import {
  failQuestionList,
  fetchQuestionList,
  successQuestionList,
  fetchUpdateQuestionList,
  failUpdateQuestionList,
  successUpdateQuestionList,
  setListedQuestions,
  setSearchDisplayType,
  setSearchDisplayOption,
  setQuestionIndex,
  setQuestionImagePath,
  setExplanationImagePath,
  setMarker,
  failSetMarker,
  successSetMarker,
} from '../actions/question';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  question: {
    isPrepared: false,
    division1: [],
    division2: [],
    division3: [],
    questions: [],
    s_division2: [],
    s_division3: [],
    explanation: {},
    listedQuestions: [],
    listedResolveQuestions: [],
    selectedQuestion: [],
    selectedResolveQuestion: [],
    searchDisplayType: '0',
    searchDisplayOption: '0',
    questionImagePath: [],
    explanationImagePath: [],
    questionIndex: 0,
    isFetching: false,
    error: undefined,
    fetchDate: undefined,
  },
};

const question = createReducer(
  {
    [fetchQuestionList]: (state) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failQuestionList]: (state, err) =>
      Object.assign({}, state, {
        isPrepared: true,
        isFetching: false,
        error: err,
      }),
    [successQuestionList]: (state, payload) =>
      Object.assign({}, state, {
        isPrepared: true,
        division1: payload.division1,
        division2: payload.division2,
        division3: payload.division3,
        questions: payload.questions,
        s_division2: payload.s_division2,
        s_division3: payload.s_division3,
        sheet: payload.sheet,
        s_sheet: payload.s_sheet,
        explanation: payload.explanation,
        isFetching: false,
        error: undefined,
        fetchDate: payload.fatchDate,
      }),
    [fetchUpdateQuestionList]: (state) =>
      Object.assign({}, state, {
        isFetching: false,
        error: undefined,
      }),
    [failUpdateQuestionList]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successUpdateQuestionList]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        error: undefined,
        division1: payload.division1,
        division2: payload.division2,
        division3: payload.division3,
        questions: payload.questions,
        updates: payload.updates,
      }),
    [setListedQuestions]: (state, payload) => Object.assign({}, state, payload),
    [setSearchDisplayType]: (state, payload) =>
      Object.assign({}, state, {
        searchDisplayType: payload.searchDisplayType,
      }),
    [setSearchDisplayOption]: (state, payload) =>
      Object.assign({}, state, {
        searchDisplayOption: payload.searchDisplayOption,
      }),
    [setQuestionIndex]: (state, payload) =>
      Object.assign({}, state, {
        questionIndex: payload,
      }),
    [setQuestionImagePath]: (state, payload) =>
      Object.assign({}, state, {
        questionImagePath: payload.questionImagePath,
      }),
    [setExplanationImagePath]: (state, payload) =>
      Object.assign({}, state, {
        explanationImagePath: payload.explanationImagePath,
      }),
    [setMarker]: (state) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failSetMarker]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successSetMarker]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        error: undefined,
        questions: payload,
      }),
  },
  initial.question
);

export default question;



// WEBPACK FOOTER //
// ./src/reducers/question.js